import { createSlice } from '@reduxjs/toolkit';
import { CountryCoverageLimitsReducer } from '../../reducers/CountryCoverageLimitsReducer';
import { CurrencyTypes } from '../../../core/enums/CurrencyTypes';

const initialState: { currency: CurrencyTypes } = {
	currency: CurrencyTypes.BRL,
};

export const countryCoverageLimits = createSlice({
	name: 'country-coverage-limits',
	initialState,
	reducers: CountryCoverageLimitsReducer,
});

export const { setCountryCoverageLimits } = countryCoverageLimits.actions;

export default countryCoverageLimits.reducer;
